var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { colors } from '../constants/styles';
import typicaLogo from '../images/typica-logo.png';
import { capitalize } from '../utils/camelize';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 30px;\n  text-align: center;\n\n  img {\n    width: 90%;\n    margin-bottom: 10px;\n  }\n"], ["\n  margin-bottom: 30px;\n  text-align: center;\n\n  img {\n    width: 90%;\n    margin-bottom: 10px;\n  }\n"])));
var RoleTitle = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: #000000;\n  background-color: ", ";\n  border-radius: 5px;\n  just: center;\n  padding: 5px 10px;\n"], ["\n  color: #000000;\n  background-color: ", ";\n  border-radius: 5px;\n  just: center;\n  padding: 5px 10px;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var SessionLogo = function (_a) {
    var role = _a.role;
    return (React.createElement(Wrapper, null,
        React.createElement("img", { src: typicaLogo }),
        React.createElement("br", null),
        React.createElement(RoleTitle, { color: colors[role] }, "For ".concat(capitalize(role), "s"))));
};
export default SessionLogo;
var templateObject_1, templateObject_2;
